import { useEffect, useRef } from 'react';

let lockCount = 0;
const originalStyles = {
  overflow: '',
  paddingRight: '',
};

/**
 * Locks the document body scroll while `locked` is true. Handles nested modals by
 * reference counting and restores the previous overflow + padding styles once the
 * last lock is released.
 */
export default function useBodyScrollLock(locked) {
  const lockRef = useRef(false);

  useEffect(() => {
    if (!locked || typeof document === 'undefined') {
      return undefined;
    }

    const body = document.body;
    const docEl = document.documentElement;

    if (!lockRef.current) {
      lockRef.current = true;
      if (lockCount === 0) {
        originalStyles.overflow = body.style.overflow;
        originalStyles.paddingRight = body.style.paddingRight;
        body.style.overflow = 'hidden';
        const scrollBarWidth = window.innerWidth - docEl.clientWidth;
        if (scrollBarWidth > 0) {
          body.style.paddingRight = `${scrollBarWidth}px`;
        }
      }
      lockCount += 1;
    }

    return () => {
      if (!lockRef.current) return;
      lockRef.current = false;
      lockCount = Math.max(lockCount - 1, 0);
      if (lockCount === 0) {
        body.style.overflow = originalStyles.overflow || '';
        body.style.paddingRight = originalStyles.paddingRight || '';
      }
    };
  }, [locked]);
}
